import styled from "styled-components";
import { themevals as theme, themevals } from "theme/themevals";
import { bp } from "theme/themevals";

export const HeaderWrapper = styled.div`    
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 1000;     
`;

export const TitleWrapper = styled.div`
  min-height: 100px;   
  display:flex;
  justify-content: space-between;
  align-items:center;        
  width: 100%;
  padding: 0 40px;
  margin: 0 auto;
  border-bottom:1px solid #EBEBEB;    
  @media (max-width: ${bp.lg})  {    
    padding: 0 25px;
  }
  @media (max-width: ${bp.sm})  {
    padding: 0 16px;
    min-height: 64px;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
`;

export const TitleInner = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  min-width: 0;
`;

export const ToggleButton = styled.button`
  margin-left: auto;
  position: relative;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  min-width: 25px;
  max-width: 25px;
  width: 25px;
  height: 20px;
  border-top: 2px solid ${themevals.colors.base_800}!important; 
  border-bottom: 2px solid ${themevals.colors.base_800}!important; 
  &:before {content: ""; display: block; height: 2px; width: 100%; background: ${themevals.colors.base_800}; position: absolute; top: 7px; left: 0;}  
  display: none;
  @media (max-width: 991px)  {    
    display: block;
  } 
`;

export const ProfileWrapper = styled.div`
  position: relative;  
  display:flex;
`;

export const DropDownToggle = styled.span`
  
`;

export const DropDown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, .1);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, .1);
  min-width: 200px;
  max-width: 100%;
`;

export const LinkWrapper = styled.div`
  span.navTitle {
    cursor: default;
    display: block;
    padding:10px;
    border-radius:5px;
  }

  span.logOut {
    cursor: pointer;
    display: block;
    padding:10px;
    border-radius:5px;
  }
`;

export const SubHeaderWrapper = styled.div`
  display:flex;
  align-items:center;    
  padding: 1rem 40px;  
  @media (max-width: ${bp.lg})  {    
    padding: 1rem 25px;
  }
  @media (max-width: ${bp.sm})  {    
    padding: 0.75rem 16px;
  }
`;

export const SubHeaderInner = styled.div`  
  width: 100%;
  margin: 0 auto;
`;

export const UserName = styled.div`
  font-size: 14px;
  font-weight: 500;
  font-family:Poppins;
  color: ${theme.colors.black};
  text-align:right;
  line-height:14px;
`;

export const RoleName = styled.div`
  font-size: 12px;
  font-weight: 400;
  font-family:Poppins;
  color: #818181;
  text-align:right;
`;

export const NameWrapper = styled.div`   
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:flex-end;
  padding-right:10px;
  @media (max-width: ${bp.md}) {
    display: none;
  }
`;

export const HeaderButtons = styled.div`
  display: flex;
  align-items:center;
  justify-content:center;
  margin-right:20px;
  @media (max-width: ${bp.sm}) {
    margin-right: 10px;
  }
`;

export const HeaderButton = styled.div`
  cursor: pointer;
  margin-left: 20px;
`;

export const EstimateToolHide = styled.div`
  @media (max-width: ${bp.lg}) {
    display: none;
  }
`;

export const ModalSubtitle = styled.div`
    font-size: 12px;
    color: ${theme.colors.dkgrey};
    font-family:"Poppins";
    font-weight:400;
`

export const ModalTitle = styled.div`
    font-size: 16px;
    font-weight: 500;
    font-family: "Rubik";
    color: ${theme.colors.base_800};
    margin-bottom:5px;
`

export const ModalIcon = styled.div`
    width:18px;
    height:18px;
    svg{
    fill:black !important;}
    display:flex;
    margin-right:10px;
`

export const ModalTitleWrapper = styled.div` 
display:flex;   
flex-direction:column;
margin-bottom:10px;
`